import { useState } from 'react';
import { inpFS } from '../../components/ui/Inputs.jsx';
import { DEVISE, fmt } from '../../lib/currency';
import { C } from '../../theme/palette';

export function ArtPicker({ catalogue, stock, onPick, onCreate, placeholder }) {
  const [q, setQ] = useState('');
  const [focus, setFocus] = useState(false);
  const ql = q.trim().toLowerCase();
  const cat = ql
    ? (catalogue || [])
        .filter(
          (a) =>
            (a.metier || '').toLowerCase().includes(ql) || (a.nom || '').toLowerCase().includes(ql),
        )
        .slice(0, 8)
    : (catalogue || []).slice(0, 6);
  const stk = ql
    ? (stock || [])
        .filter(
          (a) =>
            (a.nom || '').toLowerCase().includes(ql) || (a.cat || '').toLowerCase().includes(ql),
        )
        .slice(0, 8)
    : (stock || []).slice(0, 8);
  const exact =
    (catalogue || []).some((a) => (a.nom || '').toLowerCase() === ql) ||
    (stock || []).some((a) => (a.nom || '').toLowerCase() === ql);
  const open = focus || !!ql;
  return (
    <div style={{ marginBottom: 10 }}>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onFocus={() => setFocus(true)}
        placeholder={placeholder || '🔎 Tape ou parcours : article, prix au m²…'}
        style={inpFS}
      />
      {open && (
        <div
          style={{
            border: '1px solid ' + C.border,
            borderRadius: 9,
            marginTop: 6,
            maxHeight: 240,
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              fontSize: 7.5,
              fontWeight: 700,
              color: C.muted,
              textTransform: 'uppercase',
              padding: '7px 11px 3px',
            }}
          >
            {ql ? 'Résultats' : 'Articles disponibles — touche pour ajouter'}
          </div>
          {cat.map((a) => (
            <div
              key={a.id}
              onClick={() => {
                onPick({ nom: a.nom, u: a.u, p: a.p, ref: a.id, sd: a.sd || '' });
                setQ('');
                setFocus(false);
              }}
              style={{
                padding: '9px 11px',
                borderBottom: '1px solid ' + C.border,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <div style={{ fontSize: 10, fontWeight: 600, color: C.ink }}>{a.nom}</div>
                <div style={{ fontSize: 8, color: C.muted }}>{a.metier} · prestation</div>
              </div>
              <div style={{ fontSize: 9.5, fontWeight: 700, color: C.navy }}>
                {DEVISE} {fmt(a.p)}/{a.u}
              </div>
            </div>
          ))}
          {stk.map((a) => (
            <div
              key={'s' + a.id}
              onClick={() => {
                onPick({ nom: a.nom, u: a.u, p: a.pv, ref: a.ref, sd: '', tva: a.tva });
                setQ('');
                setFocus(false);
              }}
              style={{
                padding: '9px 11px',
                borderBottom: '1px solid ' + C.border,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <div style={{ fontSize: 10, fontWeight: 600, color: C.ink }}>{a.nom}</div>
                <div style={{ fontSize: 8, color: C.muted }}>
                  {a.cat} · stock {a.stock} {a.u}
                </div>
              </div>
              <div style={{ fontSize: 9.5, fontWeight: 700, color: C.green }}>
                {DEVISE} {fmt(a.pv)}/{a.u}
              </div>
            </div>
          ))}
          {onCreate && !exact && q.trim() && (
            <div
              onClick={() => {
                onCreate(q.trim());
                setQ('');
                setFocus(false);
              }}
              style={{ padding: '10px 11px', cursor: 'pointer', background: C.greenL }}
            >
              <div style={{ fontSize: 10, fontWeight: 800, color: C.green }}>
                ＋ Créer « {q.trim()} »
              </div>
              <div style={{ fontSize: 8, color: C.green, marginTop: 1 }}>
                Réutilisable ensuite dans tous tes devis
              </div>
            </div>
          )}
          {cat.length === 0 && stk.length === 0 && !onCreate && (
            <div style={{ padding: 12, fontSize: 9, color: C.muted, textAlign: 'center' }}>
              Aucun résultat
            </div>
          )}
          {!ql && (
            <div
              onClick={() => setFocus(false)}
              style={{
                padding: '8px 11px',
                textAlign: 'center',
                fontSize: 9,
                color: C.muted,
                cursor: 'pointer',
                borderTop: '1px solid ' + C.border,
              }}
            >
              Fermer
            </div>
          )}
        </div>
      )}
    </div>
  );
}
